import { toast } from "react-toastify";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";

export const getActivityLogs = async (setLogs, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().get("/get_actividad");
  const { data, error } = result.data;

  if (data) {
    setLogs(data);
  }

  if (error) {
    toast.error(error, toastOptions);
  }

  setIsLoading(false);
};
